module.exports = __webpack_public_path__ + "img/top-up-instapay.8a2e459c.svg";